import React, { createContext, useContext, useState, useCallback } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ConfirmCtx = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false });

  const confirm = useCallback((opts) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        title: opts?.title || "Tem certeza?",
        description: opts?.description || "Esta ação não pode ser desfeita.",
        confirmText: opts?.confirmText || "Confirmar",
        cancelText: opts?.cancelText || "Cancelar",
        destructive: !!opts?.destructive,
        resolve,
      });
    });
  }, []);

  const close = (val) => {
    state.resolve?.(val);
    setState({ open: false });
  };

  return (
    <ConfirmCtx.Provider value={confirm}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(o) => { if (!o) close(false); }}>
        <AlertDialogContent data-testid="confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{state.title}</AlertDialogTitle>
            <AlertDialogDescription>{state.description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => close(false)} data-testid="confirm-cancel">{state.cancelText}</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => close(true)}
              data-testid="confirm-ok"
              className={state.destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""}
            >
              {state.confirmText}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmCtx.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmCtx);
  if (!ctx) throw new Error("useConfirm must be used within ConfirmProvider");
  return ctx;
}
